import styled from "@emotion/styled";

import { ContentBookmark } from "~/components/content/content-bookmark";

export const Container = styled.div`
  display: flex;
  flex-flow: column;
  gap: 16px;
  justify-content: flex-start;
  align-items: center;
`;

export const StyledContentBookmark = styled(ContentBookmark)`
  inline-size: 25px;
  block-size: 28px;
  padding: 0;

  path {
    fill: #001246;
  }
`;
